module.exports = __webpack_public_path__ + "static/pattern-e005540abbeff40227c2a27ce1795ee2.png";